import { ArrowUpRight } from 'lucide-react';
import { Link, type LinkProps } from 'react-router-dom';
import type { ButtonHTMLAttributes, PropsWithChildren } from 'react';

type ButtonProps = PropsWithChildren<
  | (LinkProps & { variant?: 'primary' | 'secondary'; className?: string })
  | (ButtonHTMLAttributes<HTMLButtonElement> & {
      variant?: 'primary' | 'secondary';
      className?: string;
    })
>;

const baseStyles =
  'focus-ring group inline-flex min-h-11 items-center justify-center gap-2 rounded-full px-5 text-sm font-semibold transition duration-200';

export function Button({ children, variant = 'primary', className = '', ...props }: ButtonProps) {
  const styles =
    variant === 'primary'
      ? 'bg-crimson-500 text-white shadow-[0_10px_30px_rgba(225,29,72,0.22)] hover:bg-crimson-400 hover:shadow-[0_12px_36px_rgba(225,29,72,0.3)]'
      : 'border border-slate-700/80 bg-slate-900/50 text-slate-200 hover:border-slate-500 hover:bg-slate-800/70';

  const content = (
    <>
      {children}
      <span className="transition duration-200 group-hover:-translate-y-0.5 group-hover:translate-x-0.5">
        <ArrowUpRight size={16} strokeWidth={2.2} aria-hidden="true" />
      </span>
    </>
  );

  if ('to' in props) {
    return (
      <Link {...props} className={`${baseStyles} ${styles} ${className}`}>
        {content}
      </Link>
    );
  }

  return (
    <button {...props} className={`${baseStyles} ${styles} ${className}`}>
      {content}
    </button>
  );
}
